// Canonical invoice payment-hold reasons. Dependency-free so both the shared service
// layer AND the Deno edge functions / sync layer can import them without pulling in DAOs.
// The import paths (registerReceived, InvoiceSyncService) MUST use these constants — a
// drifting literal would no longer match MANAGED_HOLD_REASONS and the hold would become
// un-clearable.

export const ANNEX_HOLD_REASON = 'Brak zatwierdzonego oryginału aneksu VII';
export const CMR_HOLD_REASON = 'Brak zatwierdzonego oryginału CMR';
export const NOT_APPROVED_HOLD_REASON = 'Oczekuje na zatwierdzenie';
// Cash- or card-paid invoices are held until the payment is registered.
export const CASH_OR_CARD_HOLD_REASON = 'Płatność gotówką/kartą — oczekuje na rejestrację';
// Seller account below the payable trust tier (payable set = payment_verified /
// operator_verified on company_bank_accounts). Cleared automatically once an
// operator verifies the account or a settled outgoing payment promotes it.
export const UNVERIFIED_ACCOUNT_HOLD_REASON = 'Rachunek bankowy sprzedawcy niezweryfikowany';

// Legacy wordings still present in existing data (from earlier versions of the hold
// logic). They are treated as MANAGED so the sweep re-evaluates them — rewriting to the
// current reason or releasing — instead of mistaking them for manual holds and stranding
// them. Harmless if absent in a given env.
const LEGACY_HOLD_REASONS = [
  'Brak zatwierdzonego aneksu VII',            // old annex wording (no "oryginału")
  'Brak zatwierdzonego CMR',                   // old CMR wording (no "oryginału")
  'Płatność kartą — oczekuje na rejestrację',  // old card-only wording (now cash-or-card)
];

/** The hold reasons the policy engine owns — only these are auto-cleared on release.
 *  A hold_reason outside this set is treated as a manual/external hold and left alone. */
export const MANAGED_HOLD_REASONS = new Set<string>([
  ANNEX_HOLD_REASON,
  CMR_HOLD_REASON,
  NOT_APPROVED_HOLD_REASON,
  CASH_OR_CARD_HOLD_REASON,
  UNVERIFIED_ACCOUNT_HOLD_REASON,
  ...LEGACY_HOLD_REASONS,
]);

/** payment_method is raw, unnormalized Fakturownia text (e.g. 'card', 'cash', 'Gotówka',
 *  'Płatność gotówką/kartą', 'transfer', 'przelew'). Cash- or card-type methods are held
 *  until the payment is registered; transfer/compensation/etc. are not. */
export function isCashOrCardPayment(paymentMethod: string | null | undefined): boolean {
  if (!paymentMethod) return false;
  return /kart|card|got[óo]wk|cash/i.test(paymentMethod);
}
